import { mapState } from "vuex";

import DashboardLayout from "../Dashboard/layout/DashboardLayout";
// GeneralViews
import NotFound from "../Dashboard/pages/NotFoundPage";

// Admin pages
import Overview from "src/Dashboard/pages/Overview.vue";
import UserProfile from "src/Dashboard/pages/UserProfile.vue";
import Login from "src/Dashboard/pages/Auth/Login.vue";
import ForgetPassword from "src/Dashboard/pages/Auth/ForgetPassword.vue";
import ResetPassword from "src/Dashboard/pages/Auth/ResetPassword.vue";
import Users from "src/Dashboard/pages/Users/Users.vue";
import Categories from "src/Dashboard/pages/Categories/Categories.vue";
import AddCategory from "src/Dashboard/pages/Categories/AddCategory.vue";
import Materials from "src/Dashboard/pages/Materials/Materials.vue";
import AddMaterial from "src/Dashboard/pages/Materials/AddMaterial.vue";
import Products from "src/Dashboard/pages/Products/Products.vue";
import AddProduct from "src/Dashboard/pages/Products/AddProduct.vue";
import EditProduct from "src/Dashboard/pages/Products/EditProduct.vue";
import ProductDetails from "src/Dashboard/pages/Products/ProductDetails.vue";
import EditCategory from "src/Dashboard/pages/Categories/EditCategory.vue";
import AddUser from "src/Dashboard/pages/Users/AddUser.vue";
import EditUser from "src/Dashboard/pages/Users/EditUser.vue";
import Offers from "src/Dashboard/pages/Offers/Offers.vue";
import AddOffer from "src/Dashboard/pages/Offers/AddOffer.vue";
import GeneralSetting from "src/Dashboard/pages/GeneralSetting/GeneralSetting.vue";
import EditGeneralSetting from "src/Dashboard/pages/GeneralSetting/EditGeneralSetting.vue";

//Website pages
import HomeWeb from "src/Website/pages/Home.vue";
import ProductsWeb from "src/Website/pages/Products.vue";
import ProductDetailsWeb from "src/Website/pages/ProductDetails.vue";
import CategoriesWeb from "src/Website/pages/Categories.vue";
import CommonQuestion from "src/Website/pages/CommonQuestion.vue";



//Dashboard routes
const routes = [
  {
    path: "/",
    component: HomeWeb,
    redirect: "/home",
  },
  {
    path: "/admin",
    component: DashboardLayout,
    redirect: "/admin/overview",
    children: [
      {
        path: "overview",
        name: "Overview",
        component: Overview,
      },
      {
        path: "user",
        name: "User",
        component: UserProfile,
      },
      {
        path: "users",
        name: "Users",
        component: Users,
      },
      {
        path: "categories",
        name: "Categories",
        component: Categories,
      },
      {
        path: "/admin/add-category",
        name: "add-category",
        component: AddCategory,
      },
      {
        path: "materials",
        name: "Materials",
        component: Materials,
      },
      {
        path: "/admin/add-material",
        name: "add-material",
        component: AddMaterial,
      },
      {
        path: "products",
        name: "Products",
        component: Products,
      },
      {
        path: "/admin/add-product",
        name: "add-product",
        component: AddProduct,
      },
      {
        path: "/admin/edit-product/:id",
        name: "edit-product",
        component: EditProduct,
      },
      {
        path: "/admin/product-details/:id",
        name: "product-details",
        component: ProductDetails,
      },
      {
        path: "/admin/edit-category/:id",
        name: "edit-category",
        component: EditCategory,
      },
      {
        path: "/admin/add-user",
        name: "add-user",
        component: AddUser,
      },
      {
        path: "/admin/edit-user/:id",
        name: "edit-user",
        component: EditUser,
      },
      {
        path: "/admin/offers",
        name: "offers",
        component: Offers,
      },
      {
        path: "/admin/add-offer",
        name: "add-offer",
        component: AddOffer,
      },
      {
        path: "/admin/general-setting",
        name: "general-setting",
        component: GeneralSetting,
      },
      {
        path: "/admin/edit-setting",
        name: "edit-setting",
        component: EditGeneralSetting,
      },
    ],
    beforeEnter: (to, from, next) => {
      // Check if the user is logged in (you need to implement this logic)
      const userIsLoggedIn = localStorage.getItem("adminToken");
      if (!userIsLoggedIn) {
        next("/login");
      } else {
        next();
      }
    },
  },

  //Website routes
  {
    path: "/home",
    name: "home",
    component: HomeWeb,
  },
  {
    path: "/products",
    name: "products",
    component: ProductsWeb,
  },
  {
    path: "/product-details/:id",
    name: "product-details-web",
    component: ProductDetailsWeb,
  },
  {
    path: "/categories",
    name: "categories",
    component: CategoriesWeb,
  },
  {
    path: "/common-question",
    name: "CommonQuestion",
    component: CommonQuestion,
  },

  //Auth
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      const userIsLoggedIn = localStorage.getItem("adminToken");
      if (userIsLoggedIn) {
        next("/admin/overview");
      } else {
        next();
      }
    },
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    component: ForgetPassword,
    beforeEnter: (to, from, next) => {
      const userIsLoggedIn = localStorage.getItem("adminToken");
      if (userIsLoggedIn) {
        next("/admin/overview");
      } else {
        next();
      }
    },
  },
  {
    path: "/resetpassword/:token",
    name: "ResetPassword",
    component: ResetPassword,
    beforeEnter: (to, from, next) => {
      const userIsLoggedIn = localStorage.getItem("adminToken");
      if (userIsLoggedIn) {
        next("/admin/overview");
      } else {
        next();
      }
    },
  },

  //Not Found
  { path: "*", component: NotFound },
];

export default routes;